import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { IpcChannel, IpcV2Service } from 'src/app/services/ipc-v2.service';
import { environment } from 'src/environments/environment';
import { AppDownloadModalComponent } from './app-download-modal/app-download-modal.component';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [RouterLink]
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {

  version;
  loggedInUser;
  userSub:Subscription;

  constructor(public auth: AuthService, @Inject(OKTA_AUTH) public oktaAuth: OktaAuth, public yfAuth: AuthService, private router: Router,
    public dialog: MatDialog, private readonly ipcV2: IpcV2Service) {
      
  }

  getLoggedInUser() {
    return this.yfAuth.getUser()?.firstName + ' ' + this.yfAuth.getUser()?.lastName;
  }

  ngOnInit(): void {
    this.userSub = this.auth.userSub.subscribe(user => {
      if (user)
        this.loggedInUser = user.firstName + ' ' + user.lastName;
    })
  }

  async logout() {
    try {
      this.oktaAuth.revokeAccessToken()
      this.oktaAuth.revokeRefreshToken()
      this.oktaAuth.closeSession();
      this.oktaAuth.tokenManager.clear()
      this.oktaAuth.signOut();
      this.yfAuth.logout();
      localStorage.clear();
      this.router.navigate(['/']);

    } catch (error) {
      window.location.href = environment.baseUrl;
    }

  }

  openAppDownloadModal() {
    let dialogue = this.dialog.open(AppDownloadModalComponent, {
      width: '50vw',
      maxHeight: '90vh',
      ariaLabel: 'Download App',
    });
    dialogue.afterClosed().subscribe(_ => { });
    dialogue.backdropClick().subscribe(_ => { });
  }


  ngAfterViewInit(): void {
    this.ipcV2.sendAndReceive(IpcChannel.GET_VERSION).subscribe(res => {
      if (res.data) {
        this.version = res.data;
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }


}
